import { Component } from '@angular/core';
import { WidgetService } from '../../services/widget.service';
import { fireLogger } from '../../../core/utils/fire-logger';
import { GridOptions } from 'ag-grid';





@Component({
  templateUrl: 'db-page.html',
  styleUrls: ['db-page.scss'],
})
export class DbPageComponent {


  message = '';
  widgetGridRowData = [];

  widgetGridOptions = <GridOptions>{
    columnDefs: [
      {
        headerName: 'Name',
        field: 'name',
        editable: true,
        sort: 'asc',
        width: 125,
      },
    ],

    defaultColDef: {
      filter: 'text',
    },

    rowSelection: 'single',
  };


  constructor(
    private widgetService:WidgetService,
  ) {
  }



  createRecord() {

    const name = 'Goober - ' + Math.floor(Math.random() * 1000);
    const record = {
      name
    };

    this.widgetService.create(record)
      .then(() => {
        this.message = `Created record: ${name}`;
        fireLogger.log(this.message);
        setTimeout(() => { this.message = ''; }, 3000);
      })
      .catch(err => fireLogger.error('Could not create record', err));
  }


  refreshGrid() {

    this.widgetService.find({})
      .then(result => {
        fireLogger.log('result', result);
        this.widgetGridRowData = result.data;
      })
      .catch(err => fireLogger.error('Could not retrieve records', err));
  }
}



// WEBPACK FOOTER //
// E:/Projects/HaMafteach/HaMafteach Comprehensive/online-database/web-client/src/app/sample/containers/db-page/db-page.ts